// extracted by css-extract-rspack-plugin
export default {"cls1":"ToolsMenu-cls1_6uW","cls2":"ToolsMenu-cls2_Xww ToolsMenu-cls1_6uW"};